export default function () {
  if( this.processing !== false ) return

  if( typeof this.validation !== 'undefined' && this.validation() ) {

    this.processing = true
    console.log(this.input)

    setTimeout(() => {
      if (this.modelID)
        this.updateItem()
      else
        this.createItem()
    }, 500)
  }
}